<template>
	<div style="height: 90vh; overflow-y: auto">
		<wizard-modals :type="type_selected" v-if="question || add || showModalWiki || setValue"></wizard-modals>

		<div>
			<el-card class="option" style="z-index: auto; position: relative">
				<div style="display: inline-flex; width: 100%">
					<div style="margin-right: 0; margin-left: auto; width: max-content">
						<el-button
							style="z-index: auto; margin: 0 15px"
							@click="newNode({ store: $store, router: $router })"
							icon="el-icon-plus"
							type="success"
							plain
						>
							{{ $t("new-node") }}
						</el-button>
						<el-button
							style="z-index: auto; margin: 0 15px"
							plain
							type="primary"
							@click="verifyBalls() ? saveFlw() : undefined"
							>{{ $t("save") }}
						</el-button>
					</div>
				</div>
			</el-card>
		</div>
		<div style="display: inline-flex; width: 100%">
			<div style="display: inline-flex; height: 70vh; width: 100%">
				<div id="drawflow" />
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import axios from "axios"
import { goto } from "@/utils/utils"
import moment from "moment"
import { i18n } from "@/plugins/i18n"
import WizardModals from "@/modules/wizard/component/wizard-modals"

export default {
	name: "wizard-component",
	components: {
		WizardModals
	},
	computed: {
		...mapGetters({
			selected_nodes: "wizard/nodes",
			showModalEdit: "wizard/showModalEdit",
			question: "wizard/showModalQuestion",
			setValue: "wizard/setValue",
			showModalWiki: "wizard/showModalWiki",
			selected_node: "wizard/showModalEdit",
			add: "wizard/showModalInsert",
			editor: "wizard/editor"
		})
	},
	data() {
		return {
			showModal: false,
			zoom: { current: 50, precedent: 50 },

			selectedFlowchart: undefined,

			title: this.$t("new-wizard"),
			status: "",
			newTitle: "",
			editTitle: false,
			visible: false,

			idroute: undefined,
			type_selected: undefined
		}
	},

	async mounted() {
		this.resetNodes()

		if (this.$route.params.id && this.$route.params.id !== "new") {
			this.idroute = this.$route.params.id
		}

		this.openLoad()
		await this.initPage()
		this.closeLoad()
		this.loadWizards()
	},
	beforeDestroy() {
		this.kill()
	},
	watch: {
		"$route.params.id": async function (val) {
			if (val && val !== "new") {
				this.idroute = val
			}

			this.resetNodes()
			this.openLoad()
			await this.initPage()
			this.closeLoad()
			this.loadWizards()
		},
		"$route.params.selected_type": async function (val) {
			this.type_selected = val
		}
	},

	created() {
		this.type_selected = this.$route.params.selected_type
	},
	methods: {
		async initPage() {
			await this.initEditor({ store: this.$store, router: this.$router })
			return true
		},
		...mapMutations({
			openLoad: "modules/OPEN_LOADING",
			closeLoad: "modules/CLOSE_LOADING",
			setWizard: "wizard/SET_WIZ",
			setEditor: "wizard/SET_EDITOR"
		}),
		...mapActions({
			loadWizards: "wizard/loadWizards"
		}),
		goto,

		saveFlw() {
			var tosend = []
			this.selected_nodes.forEach(wiz => {
				tosend.push({
					name: wiz.titolo,
					original_id: wiz.originale,
					order: wiz.id,
					question: JSON.stringify(wiz.question),
					value: JSON.stringify(wiz.value),
					type: this.type_selected
				})
			})
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/wizard/",
					{ dati: tosend },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(async res => {
					this.goto("/wizards/" + res.data.id)
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
				})
		},

		UpdateActual() {
			this.saveFlw()
		},

		...mapActions({
			initEditor: "wizard/initEditor",
			newNode: "wizard/newNode",
			editModalEdit: "wizard/editModalEdit",
			pushNode: "wizard/pushNode",
			delNode: "wizard/delNode",
			editNodeDependecies: "wizard/editNodeDependecies",
			verifyBalls: "wizard/verifyBalls",
			cleanAndResetEditor: "wizard/cleanAndResetEditor"
		}),
		...mapMutations({
			pushNNNNNODE: "wizard/PUSH_NODE",
			resetNodes: "wizard/RESET_NODES",
			kill: "wizard/KILL_EVERYTHING"
		}),
		showConnections() {
			//for debug only
			// this.selected_nodes.forEach( el => {
			// 	console.log( "parent del nodo id: " + el.id )
			// 	console.log( el.parent )
			// 	console.log( "children del nodo id: " + el.id )
			// 	console.log( el.children )
			// 	console.log( "question del nodo id: " + el.id )
			// 	console.log( el.question )
			// 	console.log( "question map del nodo id: " + el.id )
			// 	console.log( JSON.stringify( el.question.map ) )
			// 	console.log( "answer del nodo id: " + el.id )
			// 	console.log( el.answer )
			// } )
		},
		closeEdit(event) {
			this.editModalEdit({ val: false, id: undefined })
			event.stopPropagation()
			event.preventDefault()
		},

		zooming: function (e) {
			var diff = this.zoom.current - this.zoom.precedent
			this.editor.zoom_value = Math.abs(diff) / 100
			if (diff > 0) {
				this.editor.zoom_in()
			} else {
				this.editor.zoom_out()
			}
			this.zoom.precedent = e
		},
		addNodeOutput() {
			this.selected_nodes.forEach((el, index) => {
				this.editor.addNodeOutput(index)
			})
		},
		exitEdit() {
			this.$confirm(this.$t("sure-back"), this.$t("warning"), {
				confirmButtonText: "OK",
				cancelButtonText: this.$t("cancel"),
				type: "warning"
			})
				.then(() => {
					if (this.idroute) {
						this.$parent.idx = undefined
						this.kill()
					} else if (this.$route.params.folder_id) {
						this.goto("/documents/folders/" + this.$route.params.folder_id)
					} else {
						this.goto("/documents/")
					}
				})
				.catch(() => {})
		}
	}
}
</script>
<style scoped></style>
